import { render, staticRenderFns } from "./ModalTablePaginationClient.vue?vue&type=template&id=861cd740&"
import script from "./ModalTablePaginationClient.vue?vue&type=script&lang=js&"
export * from "./ModalTablePaginationClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalTablePaginationClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports